/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppDashboardRouteImport } from './routes/_app.dashboard'
import { Route as AppMarriagesIndexRouteImport } from './routes/_app.marriages.index'
import { Route as AppMarriagesSearchRouteImport } from './routes/_app.marriages.search'
import { Route as AppMarriagesNewRouteImport } from './routes/_app.marriages.new'
import { Route as AppMarriagesIdRouteImport } from './routes/_app.marriages.$id'
import { Route as AppMarriagesEditIdRouteImport } from './routes/_app.marriages.edit.$id'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppMarriagesIndexRoute = AppMarriagesIndexRouteImport.update({
  id: '/marriages/',
  path: '/marriages/',
  getParentRoute: () => AppRoute,
} as any)
const AppMarriagesSearchRoute = AppMarriagesSearchRouteImport.update({
  id: '/marriages/search',
  path: '/marriages/search',
  getParentRoute: () => AppRoute,
} as any)
const AppMarriagesNewRoute = AppMarriagesNewRouteImport.update({
  id: '/marriages/new',
  path: '/marriages/new',
  getParentRoute: () => AppRoute,
} as any)
const AppMarriagesIdRoute = AppMarriagesIdRouteImport.update({
  id: '/marriages/$id',
  path: '/marriages/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppMarriagesEditIdRoute = AppMarriagesEditIdRouteImport.update({
  id: '/marriages/edit/$id',
  path: '/marriages/edit/$id',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/dashboard': typeof AppDashboardRoute
  '/marriages/$id': typeof AppMarriagesIdRoute
  '/marriages/new': typeof AppMarriagesNewRoute
  '/marriages/search': typeof AppMarriagesSearchRoute
  '/marriages/': typeof AppMarriagesIndexRoute
  '/marriages/edit/$id': typeof AppMarriagesEditIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/dashboard': typeof AppDashboardRoute
  '/marriages/$id': typeof AppMarriagesIdRoute
  '/marriages/new': typeof AppMarriagesNewRoute
  '/marriages/search': typeof AppMarriagesSearchRoute
  '/marriages': typeof AppMarriagesIndexRoute
  '/marriages/edit/$id': typeof AppMarriagesEditIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/marriages/$id': typeof AppMarriagesIdRoute
  '/_app/marriages/new': typeof AppMarriagesNewRoute
  '/_app/marriages/search': typeof AppMarriagesSearchRoute
  '/_app/marriages/': typeof AppMarriagesIndexRoute
  '/_app/marriages/edit/$id': typeof AppMarriagesEditIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/dashboard'
    | '/marriages/$id'
    | '/marriages/new'
    | '/marriages/search'
    | '/marriages/'
    | '/marriages/edit/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/dashboard'
    | '/marriages/$id'
    | '/marriages/new'
    | '/marriages/search'
    | '/marriages'
    | '/marriages/edit/$id'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/login'
    | '/_app/dashboard'
    | '/_app/marriages/$id'
    | '/_app/marriages/new'
    | '/_app/marriages/search'
    | '/_app/marriages/'
    | '/_app/marriages/edit/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marriages/': {
      id: '/_app/marriages/'
      path: '/marriages'
      fullPath: '/marriages/'
      preLoaderRoute: typeof AppMarriagesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marriages/search': {
      id: '/_app/marriages/search'
      path: '/marriages/search'
      fullPath: '/marriages/search'
      preLoaderRoute: typeof AppMarriagesSearchRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marriages/new': {
      id: '/_app/marriages/new'
      path: '/marriages/new'
      fullPath: '/marriages/new'
      preLoaderRoute: typeof AppMarriagesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marriages/$id': {
      id: '/_app/marriages/$id'
      path: '/marriages/$id'
      fullPath: '/marriages/$id'
      preLoaderRoute: typeof AppMarriagesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marriages/edit/$id': {
      id: '/_app/marriages/edit/$id'
      path: '/marriages/edit/$id'
      fullPath: '/marriages/edit/$id'
      preLoaderRoute: typeof AppMarriagesEditIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppDashboardRoute: typeof AppDashboardRoute
  AppMarriagesIdRoute: typeof AppMarriagesIdRoute
  AppMarriagesNewRoute: typeof AppMarriagesNewRoute
  AppMarriagesSearchRoute: typeof AppMarriagesSearchRoute
  AppMarriagesIndexRoute: typeof AppMarriagesIndexRoute
  AppMarriagesEditIdRoute: typeof AppMarriagesEditIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppDashboardRoute: AppDashboardRoute,
  AppMarriagesIdRoute: AppMarriagesIdRoute,
  AppMarriagesNewRoute: AppMarriagesNewRoute,
  AppMarriagesSearchRoute: AppMarriagesSearchRoute,
  AppMarriagesIndexRoute: AppMarriagesIndexRoute,
  AppMarriagesEditIdRoute: AppMarriagesEditIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
